import React from 'react';

import PublicMeetingComponent from '../components/public/meeting-public/index';

function PublicMeeeting() {
    return <PublicMeetingComponent />;
}

export default PublicMeeeting;
